import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import IntegrationsNav from './integrations-nav'
import { trackGetStartedClick, trackSignUpConversion } from '../utils/googleAds'
import './dark-nav.css'

const DarkNav = () => {
  const [scrolled, setScrolled] = useState(false)
  const [mobileOpen, setMobileOpen] = useState(false)

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20)
    window.addEventListener('scroll', onScroll)
    return () => window.removeEventListener('scroll', onScroll)
  }, [])

  const handleGetStarted = () => {
    trackGetStartedClick()
    trackSignUpConversion()
  }

  return (
    <nav className={`dark-nav${scrolled ? ' dark-nav--scrolled' : ''}${mobileOpen ? ' dark-nav--open' : ''}`}>
      <div className="dark-nav-inner">
        <Link to="/" className="dark-nav-logo">
          <img src="/dataflows-high-resolution-logo-200h.png" alt="DataFlows" height="34" />
        </Link>

        <div className="dark-nav-links">
          <Link to="/#features">Features</Link>
          <Link to="/#pricing">Pricing</Link>
          <Link to="/blog">Blog</Link>
          <IntegrationsNav />
          <Link to="/developers">Developers</Link>
          <Link to="/contact-us">Contact Us</Link>
        </div>

        <div className="dark-nav-actions">
          <a href="https://sms.dataflows.com.au" target="_blank" rel="noreferrer noopener" className="dark-nav-signin">Sign in</a>
          <a href="https://sms.dataflows.com.au/register" target="_blank" rel="noreferrer noopener" className="dark-nav-cta" onClick={handleGetStarted}>Get started</a>
        </div>

        <button className="dark-nav-hamburger" onClick={() => setMobileOpen(!mobileOpen)} aria-label="Toggle menu">
          {mobileOpen
            ? <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M18 6L6 18M6 6l12 12"/></svg>
            : <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M3 12h18M3 6h18M3 18h18"/></svg>
          }
        </button>
      </div>

      {mobileOpen && (
        <div className="dark-nav-mobile">
          <Link to="/#features" onClick={() => setMobileOpen(false)}>Features</Link>
          <Link to="/#pricing" onClick={() => setMobileOpen(false)}>Pricing</Link>
          <Link to="/blog" onClick={() => setMobileOpen(false)}>Blog</Link>
          <Link to="/integrations" onClick={() => setMobileOpen(false)}>Integrations</Link>
          <Link to="/developers" onClick={() => setMobileOpen(false)}>Developers</Link>
          <Link to="/contact-us" onClick={() => setMobileOpen(false)}>Contact Us</Link>
          <div className="dark-nav-mobile-actions">
            <a href="https://sms.dataflows.com.au" target="_blank" rel="noreferrer noopener" className="dark-nav-signin">Sign in</a>
            <a href="https://sms.dataflows.com.au/register" target="_blank" rel="noreferrer noopener" className="dark-nav-cta" onClick={handleGetStarted}>Get started</a>
          </div>
        </div>
      )}
    </nav>
  )
}

export default DarkNav
